module.exports = __webpack_public_path__ + "assets/img/145.c56d6532.png";